import { render, staticRenderFns } from "./c-address-container.vue?vue&type=template&id=48494802&scoped=true&"
import script from "./c-address-container.vue?vue&type=script&lang=js&"
export * from "./c-address-container.vue?vue&type=script&lang=js&"
import style0 from "./c-address-container.vue?vue&type=style&index=0&id=48494802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48494802",
  null
  
)

export default component.exports